import React, {useEffect, useState} from "react";
import {Button, Col, Input, Row} from "antd";
import {useNavigate, useSearchParams} from "react-router-dom";
import SelectContentKhachHangMobile from "../content/SelectContentKhachHangMobile";
import SelectContentBienSoMobile from "../content/SelectContentBienSoMobile";
import SelectContentTenHangMobile from "../content/SelectContentTenHangMobile";
import {LeftOutlined} from "@ant-design/icons";

const CalendarModalFilter = ({code, onCancel, visible}) => {

    const height = window.innerHeight;
    const [searchParams] = useSearchParams()
    const [value , setValue] = useState(searchParams.get('search'))
    const navigate = useNavigate();
    const [defaultValueKh, setDefaultValueKh] = useState([])
    const [defaultValueSx, setDefaultValueSx] = useState([])
    const [defaultValueTh, setDefaultValueTh] = useState([])

    useEffect(()=>{
        setDefaultValueKh(searchParams.getAll('khachHang'))
        setDefaultValueTh(searchParams.getAll('tenHang'))
        setDefaultValueSx(searchParams.getAll('soXe'))
    },[searchParams, visible])

    const submit = () =>{

        searchParams.delete("khachHang")
        if (defaultValueKh.length > 0 ){
            defaultValueKh.map((item)=>{
                searchParams.append("khachHang", item)
                return []
            })
        }

        searchParams.delete("tenHang")
        if (defaultValueTh.length > 0 ){
            defaultValueTh.map(item=>{
                searchParams.append("tenHang", item)
                return []
            })
        }

        searchParams.delete("soXe")
        if (defaultValueSx.length > 0 ){
            defaultValueSx.map(item=>{
                searchParams.append("soXe", item)
                return []
            })
        }

        searchParams.delete("search")
        if (value && value !== "") {
            searchParams.append("search", value)
        }
        navigate(`?${searchParams.toString()}`)

        onCancel()
    }

    return (
        <>

            <div className={"text-center p-3 opacity-80 text-black"} id={"title_h2"}>
                <Row className={"items-center"}>
                    <Col span={2}>
                        <LeftOutlined style={{fontSize: 14}}
                                      onClick={() => {
                                          onCancel()
                                      }}/>
                    </Col>
                    <Col span={18}>
                        Chọn điều kiện lọc
                    </Col>
                    <Col span={4}>
                        <Button type={"link"}
                                className={"font-semibold"} onClick={()=>submit()}> Lưu </Button>
                    </Col>
                </Row>
            </div>

            <div className={"px-2"} style={{ maxHeight: height - 32 - 52 }}>
                <div className={'pt-6'}>
                    <Input placeholder={"Chứa nội dung"}
                           style={{width: "100%"}}
                           rootClassName={"customer_input_filter "}
                           onChange={e => {
                               setValue(e.target.value)
                           }}
                           value={value} />
                </div>

                <div>
                    <SelectContentKhachHangMobile code={code}
                                                  defaultValueKh={defaultValueKh}
                                                  setDefaultValue={(value)=>setDefaultValueKh(value)}/>
                </div>
                <div>
                    <SelectContentBienSoMobile code={code}
                                               visible={visible}
                                               defaultValueSx={defaultValueSx}
                                               setDefaultValue={(value)=>setDefaultValueSx(value)}/>
                </div>
                <div>
                    <SelectContentTenHangMobile code={code}
                                                visible={visible}
                                                defaultValueTh={defaultValueTh}
                                                setDefaultValue={(value)=>setDefaultValueTh(value)}/>
                </div>
            </div>
        </>
    )
}

export default CalendarModalFilter
